<template>
  <!--  这是充值页面   -->
  <div class="home_wrap">
    <div class="header">
      <span style="font-size: .5rem;font-family: cursive;float: left;margin-left: .2rem;" class="back"
        @click="$parent.$parent.isShowRecharge = false">
        <van-icon name="arrow-left" />
      </span>
      <span style="text-align: center;font-size: .45rem;color: #fff;margin-left: .8rem;">Depósito</span>
      <i style="float: right;margin-right: .2rem;">
        <span @click="tosup">
          <svg width="20" height="20" class="kefu" style="margin-right: .2rem;" viewBox="0 0 56 56">
            <g id="ah6sqCmI-comm_icon_cz_kf" transform="translate(-338.563 -2482.325)">
              <path id="ah6sqCmI-联合_620" data-name="联合 620"
                d="M14912.431,5249a6.723,6.723,0,0,1,13.184-1.857h7.193l3.173-9.152a5.26,5.26,0,0,1-3.51-4.966v-7.362a5.282,5.282,0,0,1,4.418-5.2,15.948,15.948,0,0,0-15.858-15.427h-.476a15.951,15.951,0,0,0-15.858,15.427,5.28,5.28,0,0,1,4.422,5.2v7.362a5.283,5.283,0,0,1-5.27,5.266h-2.021a5.278,5.278,0,0,1-5.267-5.266v-7.362a5.273,5.273,0,0,1,4.423-5.2,18.644,18.644,0,0,1,1.563-7.366,19.094,19.094,0,0,1,4.257-6.14,19.708,19.708,0,0,1,6.294-4.122,20.388,20.388,0,0,1,15.39,0,19.724,19.724,0,0,1,6.293,4.126,19.022,19.022,0,0,1,4.258,6.136,18.564,18.564,0,0,1,1.563,7.366,5.293,5.293,0,0,1,4.426,5.2v7.362a5.281,5.281,0,0,1-5.225,5.266l-3.919,11.316a1.859,1.859,0,0,1-1.756,1.249h-8.51a6.724,6.724,0,0,1-13.187-1.856Zm4.591-2.127a2.965,2.965,0,0,0-.878,2.127,3.012,3.012,0,1,0,3.008-3.012A2.984,2.984,0,0,0,14917.021,5246.87Zm19.162-21.21v7.362a1.557,1.557,0,0,0,1.557,1.557h2.021a1.557,1.557,0,0,0,1.553-1.557v-7.362a1.556,1.556,0,0,0-1.553-1.557h-2.021A1.557,1.557,0,0,0,14936.184,5225.66Zm-35.909,0v7.362a1.557,1.557,0,0,0,1.553,1.557h2.021a1.558,1.558,0,0,0,1.557-1.557v-7.362a1.558,1.558,0,0,0-1.557-1.557h-2.021A1.556,1.556,0,0,0,14900.274,5225.66Z"
                transform="translate(-14554.227 -2718.238)" />
              <rect id="ah6sqCmI-矩形_3312" data-name="矩形 3312" width="56" height="56"
                transform="translate(338.563 2482.325)" opacity="0" />
            </g>

          </svg>
        </span>

        <svg width="20" height="20" class="kefu" viewBox="0 0 56 56" @click="toRecord">
          <defs>
            <clipPath id="yVXGXaDS-clip-path">
              <rect id="yVXGXaDS-矩形_3360" data-name="矩形 3360" width="56" height="56"
                transform="translate(-9003.117 7343.883)" stroke-width="1" />
            </clipPath>
          </defs>
          <g id="yVXGXaDS-comm_icon_cz_jl" transform="translate(9003.117 -7343.883)"
            clip-path="url(#yVXGXaDS-clip-path)">
            <path id="yVXGXaDS-联合_619" data-name="联合 619"
              d="M5477.7,10114.192a16.013,16.013,0,0,1,6.113-30.81h.013a16.014,16.014,0,1,1-6.125,30.81Zm1.391-26.22a12.361,12.361,0,1,0,4.719-.938A12.395,12.395,0,0,0,5479.1,10087.973Zm-23.658,22.719a6.564,6.564,0,0,1-6.555-6.56v-34.693a6.561,6.561,0,0,1,6.555-6.555h26.811a6.56,6.56,0,0,1,6.552,6.555V10076h-3.65v-6.558a2.905,2.905,0,0,0-2.9-2.9h-26.813a2.908,2.908,0,0,0-2.9,2.9v34.581l0,0v.106a2.9,2.9,0,0,0,2.9,2.9h8.134v3.655Zm33.487-3.681-6.417-6.434a1.709,1.709,0,0,1-.452-.817v-.01a.6.6,0,0,1-.03-.155l0-.018v-.059a21.265,21.265,0,0,1-.028-2.3v-5.7a1.825,1.825,0,1,1,3.651,0v7.218l5.773,5.783a1.764,1.764,0,0,1-.751,3.033,1.812,1.812,0,0,1-.421.051A1.779,1.779,0,0,1,5488.925,10107.011Zm-30.334-19.975a1.827,1.827,0,0,1,0-3.653h6.311a1.827,1.827,0,0,1,0,3.653Zm0-9.456a1.825,1.825,0,0,1,0-3.65h20.5a1.825,1.825,0,1,1,0,3.65Z"
              transform="translate(-14449.841 -2716.841)" />
          </g>

        </svg>
      </i>
    </div>
    <div class="base-header">
      <!-- <div
        :class="is_active ? 'big_tit is-active' : 'big_tit'"
        @click="show_game_box = false"
      >
        {{ $t("充值") }}
      </div>
      <div class="big_tit" @click="$router.push('withdraw')">
        {{ $t("提现") }}
      </div> -->
      <div class="tab_nav">
        <van-tabs v-model="nav_active" shrink class="van-tabs__wrap--scrollable" :sticky="false" :swipeable="true"
          :swipe-threshold="2" line-width="1.5rem" :background="'transparent'" :color="'#fff0bb'" @change="tabChange">
          <van-tab>
            <template #title>
              <div class="nav_title">
                <svg width="1.1em" height="1.1em" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="m-wrap">
                  <path
                    d="M26.9319 47.312H8.53899C7.32338 47.3145 6.15643 46.8347 5.29416 45.9778C4.43188 45.121 3.94468 43.9571 3.93945 42.7415L3.93945 7.25709C3.94468 6.04149 4.43188 4.8776 5.29416 4.02076C6.15643 3.16391 7.32338 2.68408 8.53899 2.68653H26.9464C28.1625 2.68828 29.3283 3.17245 30.1879 4.03279C31.0475 4.89313 31.5307 6.05935 31.5314 7.27553V24.1102C30.4868 24.4529 29.489 24.9246 28.5612 25.5143V9.51339C28.5595 9.10827 28.397 8.7204 28.1096 8.43493C27.8221 8.14945 27.4331 7.9897 27.028 7.99075H8.58772C8.18238 7.98935 7.79305 8.14894 7.50532 8.43446C7.21758 8.71997 7.05497 9.10805 7.05323 9.51339V39.0403C7.04302 39.4091 7.16942 39.7686 7.40816 40.0499C7.6469 40.3312 7.98113 40.5143 8.34668 40.5642H22.9935C23.832 43.2369 25.5038 45.571 27.7643 47.2251C27.4901 47.2796 27.2114 47.3087 26.9319 47.312ZM18.1411 42.428C17.8167 42.4301 17.5002 42.5282 17.2315 42.7099C16.9628 42.8917 16.7539 43.1489 16.6312 43.4492C16.5085 43.7495 16.4774 44.0794 16.542 44.3974C16.6066 44.7153 16.7638 45.007 16.9939 45.2356C17.2241 45.4643 17.5167 45.6197 17.8351 45.6822C18.1534 45.7447 18.4831 45.7116 18.7826 45.5869C19.0821 45.4623 19.338 45.2518 19.5181 44.9819C19.6981 44.7121 19.7941 44.3949 19.7942 44.0705C19.7942 43.8539 19.7513 43.6395 19.6681 43.4395C19.5849 43.2395 19.463 43.058 19.3094 42.9053C19.1557 42.7527 18.9734 42.6319 18.7729 42.55C18.5724 42.4681 18.3577 42.4266 18.1411 42.428ZM35.6831 46.9617C33.6458 46.9492 31.6578 46.3337 29.9699 45.1927C28.282 44.0517 26.9698 42.4365 26.1987 40.5506C25.4277 38.6648 25.2325 36.5929 25.6376 34.5962C26.0427 32.5995 27.03 30.7675 28.475 29.3313C29.9201 27.8951 31.7581 26.919 33.7572 26.5261C35.7563 26.1332 37.827 26.3411 39.7081 27.1236C41.5891 27.9061 43.1964 29.2282 44.327 30.923C45.4576 32.6179 46.061 34.6096 46.061 36.647C46.0611 38.0069 45.7922 39.3533 45.2699 40.6089C44.7476 41.8645 43.9821 43.0044 43.0176 43.963C42.0531 44.9217 40.9085 45.6801 39.6498 46.1947C38.391 46.7094 37.043 46.97 35.6831 46.9617ZM35.4737 42.5874L37.3836 42.6032C36.5512 41.7019 35.9394 40.6198 35.5962 39.442C36.1766 39.9439 36.847 40.331 37.5719 40.5827C38.0401 40.6812 38.5251 40.6668 38.9866 40.5407C39.4482 40.4146 39.873 40.1803 40.226 39.8573C40.579 39.5343 40.85 39.1319 41.0165 38.6833C41.183 38.2348 41.2403 37.753 41.1836 37.2779C41.1533 35.6538 39.9678 34.5724 38.4663 33.2052C37.3839 32.264 36.3844 31.2315 35.4789 30.1191C34.5731 31.2025 33.5797 32.2096 32.5087 33.1301C31.0006 34.4855 29.8099 35.5564 29.7611 37.1936C29.696 37.6694 29.7454 38.1539 29.9051 38.6068C30.0649 39.0597 30.3303 39.468 30.6795 39.7977C31.0287 40.1275 31.4515 40.3691 31.9128 40.5027C32.3741 40.6362 32.8606 40.6578 33.332 40.5655C34.0795 40.3159 34.7763 39.9345 35.3894 39.4394C35.0347 40.6145 34.41 41.6903 33.5651 42.5808C34.7097 42.5953 35.1813 42.5979 35.3736 42.5979H35.4789L35.4737 42.5874Z"
                    fill="#ccc" />
                </svg>
                <span class="ppl">{{ $t("网上存款") }}</span>
              </div>
            </template>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="Currency">
      <div class="Currency_title">
        <img src="https://fsdgsfdg.brandypgapp.com/siteadmin/upload/img/finance-1734045106159-226073.avif" alt="">
        <span>PIX</span>
        <div class="svg_icon">
          <svg width="25" height="14" viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="m-wrap">
            <g clip-path="url(#clip0_6948_48956)">
              <path d="M0 19L32 0V11.5C32 15 29.0462 19 25.6 19H0Z" fill="#1E62F5" />
              <path d="M18 11.7521L21.1999 14.8485C21.4087 15.0505 21.7472 15.0505 21.9561 14.8485L28 9"
                class="stroke_path" stroke="white" stroke-width="1.03079" stroke-linecap="round" />
            </g>
            <defs>
              <clipPath id="clip0_6948_48956">
                <rect width="32" height="19" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
    <div class="Currency2">
      <div v-for="(item, index) in rechargeChannel" :class="currencyValue === item.name
        ? 'chose_money Currency_title'
        : 'Currency_title'
        " @click="choseCurrency(item.name)">
        <span>{{ item.title }}</span>
        <div v-if="currencyValue === item.name" class="svg_icon">
          <svg width="25" height="14" viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="m-wrap">
            <g clip-path="url(#clip0_6948_48956)">
              <path d="M0 19L32 0V11.5C32 15 29.0462 19 25.6 19H0Z" fill="#1E62F5" />
              <path d="M18 11.7521L21.1999 14.8485C21.4087 15.0505 21.7472 15.0505 21.9561 14.8485L28 9"
                class="stroke_path" stroke="white" stroke-width="1.03079" stroke-linecap="round" />
            </g>
            <defs>
              <clipPath id="clip0_6948_48956">
                <rect width="32" height="19" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <!-- <div
        :class="
          currencyValue === 'novo pagamento'
            ? 'chose_money Currency_title'
            : 'Currency_title'
        "
        @click="choseCurrency('novo pagamento')"
      >
        <span>novo pagamento</span>
        <div class="svg_icon" v-if="currencyValue === 'novo pagamento'">
          <svg
            width="25"
            height="14"
            viewBox="0 0 32 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="m-wrap"
          >
            <g clip-path="url(#clip0_6948_48956)">
              <path
                d="M0 19L32 0V11.5C32 15 29.0462 19 25.6 19H0Z"
                fill="#1E62F5"
              ></path>
              <path
                d="M18 11.7521L21.1999 14.8485C21.4087 15.0505 21.7472 15.0505 21.9561 14.8485L28 9"
                class="stroke_path"
                stroke="white"
                stroke-width="1.03079"
                stroke-linecap="round"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_6948_48956">
                <rect width="32" height="19" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div> -->
    </div>

    <form class="form">
      <div class="tips_wrap">
        <p class="recharge_amount_p">
          {{ $t("定金") }}
        </p>
      </div>

      <div class="recharge_wrap">
        <div v-for="(i, k) in rechargeConfigList" :key="k"
          :class="Number(i.money) == Number(data.money) ? 'chose_money fast-money' : 'fast-money'"
          @click="chmoney(i.money)">
          {{ i.money }}
          <div v-if="Number(i.money) == Number(data.money)" class="svg_money_icon">
            <svg width="25" height="14" viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="m-wrap">
              <g clip-path="url(#clip0_6948_48956)">
                <path d="M0 19L32 0V11.5C32 15 29.0462 19 25.6 19H0Z" fill="#1E62F5" />
                <path d="M18 11.7521L21.1999 14.8485C21.4087 15.0505 21.7472 15.0505 21.9561 14.8485L28 9"
                  class="stroke_path" stroke="white" stroke-width="1.03079" stroke-linecap="round" />
              </g>
              <defs>
                <clipPath id="clip0_6948_48956">
                  <rect width="32" height="19" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="recharge_bonus" v-if="i.gift_amount > 0">+{{ i.gift_amount }} <span></span></div>
        </div>
      </div>
      <div class="flex_center">
        <div>{{ $t("钱符") }}</div>
        <input v-model.trim="data.money" type="number" step="10" class="inp" placeholder="Mínimo 10, Máximo 50000,00"
          @input="changeAmount">
        <div v-if="data.money == '' ? false : true" @click="clear">
          <svg focusable="false" class="clear" data-icon="close-circle" width="1em" height="1em" fill="#ccc"
            aria-hidden="true" viewBox="64 64 896 896">
            <path
              d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" />
          </svg>
        </div>
      </div>
    </form>
    <!-- <div class="tip">
      <p>
      <div class="tip_title">Recarregue a atividade do retorno da água：</div>
      <div class="tip_title">
        após o número de recarga<span class="red"> >1</span>, cada recarga retornará <span class="red">5%-15%</span> da
        água
        corrente gerada após a última recarga
      </div>
      </p>
    </div>
    <div class="tip">
      <p>
        Lembrete：Prezado Cliente: Olá! Para que possa retirar dinheiro para a
        sua conta em tempo útil, certifique-se de que preenche um número e um
        nome de conta verdadeiros e válidos e verifique cuidadosamente se estão
        correctos ,obrigado！
      </p>
    </div> -->
    <div class="tip">
      <p>
        {{ $t("温馨提示：尊敬的客户：您好！为了您能及时提款到您的账户，请务必填写真实有效的账号及姓名，并仔细核对是否正确，谢谢！") }}
      </p>
    </div>

    <div class="sbtn" @click="submit">
      {{ $t("立即存款") }}
    </div>

    <div v-show="show_game_box" id="bigBoxRe" class="game-box">
      <van-icon class="icon" name="arrow-left" @click="back" />
      <!-- <iframe :src="game_url" frameborder="0" id="myiframe"></iframe> -->
    </div>

    <!-- <ft></ft> -->
    <!-- <ftNav :active="2"></ftNav> -->
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox, RadioGroup, Icon, Radio, Tabs, Tab, NavBar } from "vant";
import Fetch from "../../utils/fetch";
import ftNav from "../../components/footer_nav/footer_nav";
import { EventBus } from '../../utils/utils'
import ft from "../../components/ft.vue";

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CountDown).use(Checkbox).use(Icon).use(Tabs).use(Tab);

export default {
  name: "Recharge",
  components: {
    ftNav,
    ft,
  },
  data() {
    return {
      isShowBonus: true,
      time: 0,
      eye: 1,
      balance: 0.0,
      data: {
        choose: "",
        channel: "",
        money: "",
        min_money: "",
        id: "",
        reason: "there is no need to fill",
      },
      recharge_list: [],
      payment: [],
      payment_index: 0,
      config: {},
      actualAmount: "",
      bonus: 0,
      show_game_box: false,
      is_active: true,
      min_money: 0,
      rechargeConfigList: [],
      is_open: false,
      nav_active: 0,
      currencyValue: 'pix1',
      showClear: false,
      rechargeChannel: []
    };
  },
  created() {
    this.$bus.$emit("send2ftnav", 2);
  },
  mounted() {
    this.recharge_list = [10, 30, 50, 100, 500, 1000, 3000, 5000, 10000, 50000];
    console.log(this.$route.name);
    if (this.$route.name == "invest") {
      this.is_active = true;
    }
    Fetch("/recharge/init").then((res) => {
      // this.is_open = res.data.is_open;
      if (res.data) {
        this.rechargeConfigList = res.data.config;
        this.rechargeChannel = res.data.channel;
        this.currencyValue = res.data.channel[0].name;
        this.data.min_money = res.data.min_recharge;
        res.data.is_first_recharge == 1
          ? (this.isShowBonus = false)
          : (this.isShowBonus = true);
      }
    });
  },
  methods: {
    tabChange(v) { },
    back() {
      if (this.show_game_box) {
        document
          .getElementById("bigBoxRe")
          .removeChild(document.getElementById("myiframe"));
        this.show_game_box = false;
        this.$parent.$parent.isShowRecharge = false;
      } else {
        this.$router.go(-1);
      }
    },
    getBonus(recharge_amount) {
      let bns = 0;
      for (let i = 0; i < this.rechargeConfigList.length; i++) {
        if (
          recharge_amount >= this.rechargeConfigList[i]["min_money"] &&
          recharge_amount <= this.rechargeConfigList[i]["max_money"]
        ) {
          bns = this.rechargeConfigList[i]["gift_amount"];
          break;
        }
      }
      return bns;
    },
    getBID(recharge_amount) {
      let bid = 0;
      this.rechargeChannel.forEach(item => {
        if (item.name == recharge_amount) {
          bid = item.id;
        }
      })
      return bid;
    },
    ki(v) {
      return Math.round(v);
    },
    toRecord() {
      this.$parent.$parent.isShowRecharge = false;
      this.$router.push({ name: "record", query: { tab: 1 } });
    },
    tosup() {
      this.$parent.$parent.isShowRecharge = false;
      this.$parent.$parent.isShowSupport = true;
      EventBus.$emit('supTabChange', 0);
    },
    chmoney(i) {
      this.data.money = i;
      return false;
    },
    checkLimit() {
      const key = "invest_button";
      const ttl = 60;
      let now = Date.parse(new Date()) / 1000;
      let val = localStorage.getItem(key);
      if (!val) {
        val = JSON.stringify({
          ttl: now + ttl,
        });
        localStorage.setItem(key, val);
        return true;
      } else {
        val = JSON.parse(val);
        if (val["ttl"] > now) {
          return false;
        } else {
          val = JSON.stringify({
            ttl: now + ttl,
          });
          localStorage.setItem(key, val);
          return true;
        }
      }
    },

    submit() {
      if (!this.data.money || this.data.money < this.data.min_money) {
        this.$toast(this.$t("最低充值金额为R$") + this.data.min_money);
        return false;
      }

      //got the money
      localStorage.setItem("recharge_money", this.data.money);

      //pass go recharge
      this.$toast.loading({ mask: true, duration: 0 });
      this.payment_index = this.getBID(this.currencyValue);
      //console.log(this.payment_index);return;
      console.log(this.payment_index, this.isShowBonus);
      Fetch(
        "/recharge/create",
        {
          money: this.data.money,
          channel_id: this.payment_index,
          name: this.currencyValue
        },
        null,
        false
      )
        .then((r) => {
          if (r.code == 1) {
            //console.log(r);
            if (r.data.pay_url.indexOf("http") != -1) {
              if (this.loadUrl(r.data.pay_url)) this.$router.push("/");
            }
            //ok go the page
            this.$toast.clear();
          } else {
            this.$toast.clear();
            this.$toast(this.$t("系统繁忙,请稍后再尝试"));
          }
        })
        .catch((er) => {
          //recharge failed by upstream channel
          this.$toast.clear();
          this.$toast({
            message: this.$t("系统繁忙,请稍后再尝试"),
            duration: 5000,
          });
        });
    },
    loadUrl(url) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "yes");
      iframe.setAttribute("id", "myiframe");
      iframe.setAttribute("src", url);
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      iframe.addEventListener("error", function () {
        let u = navigator.userAgent;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
        if (isIOS) {
          window.location.href = url;
        } else {
          window.open(url);
        }
      });
      var bigBoxRe = document.getElementById("bigBoxRe");
      bigBoxRe.appendChild(iframe);
    },
    changeAmount() {
      this.data.money = this.data.money

    },
    choseCurrency(value) {
      this.currencyValue = value;
    },
    clear() {
      this.data.money = "";
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

.logo {
  width: 100%;
  text-align: center;

  img {
    width: 80%;
  }
}

.clear {
  fill: @textcolor1;
}

.tip {
  // margin-left: 4%;
  // margin-top: 0.21053rem;
}

.myteam-bg {
  width: 100%;
  height: 3rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.header {
  text-align: center;
  box-sizing: border-box;

  .back {
    color: @textcolorf;
  }
}

.ades {
  width: 95%;
  margin: 15px auto;
  font-size: 0.37rem;
  color: rgba(255, 255, 255, 0.737);
  line-height: 24px;
  text-indent: 10px;
  color: goldenrod;
}

.m-wrap path {
  fill: @rechargeColor;
}

.base-header {
  color: @rechargeColor;
}

.ppl {
  color: @rechargeColor;
  font-size: 0.3rem;
  margin-left: 0.2rem;
}

.stroke_path {
  stroke: @primary-color;
}

/deep/.van-tab {
  justify-content: flex-start;
  border-bottom: 0.01rem solid @textcolor1;
}

/deep/ .van-tabs__line {
  left: -3rem;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  width: 100%;
}

.Currency {
  padding: 0.4rem 0.3rem;
  border-bottom: 0.01rem solid @textcolor1;

  .Currency_title {
    display: flex;
    align-items: center;
    height: 0.8rem;
    border: 0.01rem solid @rechargeColor;
    width: 30%;
    line-height: 1rem;
    border-radius: 0.2rem;
    position: relative;
    justify-content: space-between;

    span {
      margin-right: 0.7rem;
      font-size: 0.3rem;
      color: @rechargeColor !important;
    }

    img {
      width: 0.5rem;
      margin-left: 0.2rem;
    }
  }
}

.tip_title {
  color: @rechargeColor;
}

.red {
  color: red !important;
}

.Currency2 {
  padding: 0.2rem 0.3rem;
  border-bottom: 0.03rem solid @textcolor1;
  display: flex;

  .Currency_title {
    display: flex;
    align-items: center;
    height: 0.8rem;
    border: 0.01rem solid @textcolor1;
    width: 30%;
    line-height: 1rem;
    border-radius: 0.2rem;
    position: relative;
    justify-content: center;
    margin-right: 0.2rem;

    .Fogosa {
      width: 1.5rem;
      position: absolute;
      right: 0;
      height: 0.6rem;
      top: -0.7rem;

      span {
        position: relative;
        z-index: 2;
      }

      img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: -0.2rem;
        z-index: 1;
        top: 0.3rem;
      }
    }

    span {
      font-size: 0.3rem;
      color: #fff;
    }
  }
}

.kefu {
  fill: @rechargeColor;
}

.svg_icon {
  position: absolute;
  bottom: -0.41rem;
  right: -0.01rem;
}

.svg_money_icon {
  position: absolute;
  bottom: -0.1rem;
  right: 0;
}

.big_tit {
  font-size: 0.35rem;
  text-align: center;
  width: 49%;
  height: 0.7rem;
  line-height: 0.7rem;
  color: #fff;
  border-radius: 0.1rem;
}

.is-active {
  background: @anttextcolor;
  color: @primary-color;
}

.telegram {
  position: absolute;
  width: 1.3rem;
  bottom: 100px;
  right: 20px;
  z-index: 1;
}

.back_left {
  background-size: 14px 20px;
  background-position: center;
  width: 15%;
}

.game-box {
  position: fixed;
  box-sizing: border-box;
  width: 100%;
  max-width: @maxWidth;
  top: 0;
  bottom: 0;
  // left: 50%;
  // margin-left: calc(-50%);
  // right: 0;
  background: white;
  z-index: 999;
  overflow: scroll;

  .icon {
    position: absolute;
    color: #434343;
    left: 15px;
    top: 15px;
    font-size: 20px;
  }

  // margin-left:calc(-50%);
}

.flex_center {
  padding: 4px 5px;
  color: #fff;
  justify-content: flex-start;
  border: thin solid @textcolor1;
  //background-color: #1e1e1e;
  border-radius: 0.2rem;
  margin-bottom: 0.3rem;
  position: relative;
  font-size: 0.4rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 700;
}

.tree {
  position: absolute;
  height: 0.85rem;
  right: 0;
  bottom: 0;
  font-weight: 700;
}

.flex_center>div {
  font-weight: 700;
  text-align: center;
  margin-left: 5px;
  margin-right: 3px;
}

.inp {
  width: 86%;
  height: 0.6rem;
  font-size: 0.4rem;
  color: @textcolor1;
  font-weight: 700;
  background-color: transparent;
  border: none;

  &::placeholder {
    color: @disableColor;
  }
}

.chose_money {
  border: 0.01rem solid @rechargeColor !important;
  color: @anttextcolor;
}

.fast-money {
  // width: 25%;
  text-align: center;
  margin-bottom: 0.2rem;
  border-radius: 6px;
  float: left;
  //color: #fff;
  font-size: 0.4rem;
  display: flex;
  padding: 0.35rem 0.26rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border: thin solid @textcolor1;
  position: relative;
  color: @textcolor3;
}

.recharge_bonus {
  position: absolute;
  font-weight: 700;
  top: -10px;
  right: 0px;
  background: #ff1f07;
  border-radius: .2rem .2rem .2rem 0;
  color: #ff0;
  font-size: .28rem;
  padding: .1rem;

  span {
    display: block;
    border-radius: 0;
    width: .3rem;
    height: .3rem;
    background: linear-gradient(135deg, #ff1f07, #ff1f07 50%, transparent 0, transparent);
    position: absolute;
    bottom: -.15rem;
    left: 0;
  }
}

.mactive_b {
  font-size: 0.3rem;
  color: #9703aa;
}

.ml66 {
  font-size: 0.3rem;
  color: gold;
}

.nav_title {
  display: flex;
  align-items: center;
}

.ml5 {
  margin-left: 5%;
}

.top_right {
  position: absolute;
  font-size: 13px;
  line-height: 18px;
  color: #ffffff;
  top: 36px;
  right: 14px;
}

.recharge_fs {
  margin-top: 10px;
  background: #0e411488;
  border-radius: 6px;
  padding: 0 16px;

  .tit {
    background-image: linear-gradient(to bottom, #ffffff, #97eba7);
    color: transparent;
    //-webkit-background-clip: text;
  }
}

.recharge_box {
  width: 100%;
  height: 48px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  margin-top: 12px;
  padding: 16px 11px;
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  padding-top: 0.2rem;
  background-color: @secondary-color;
  //background-color: rgba(0,0,0,0.5);
  //color: #fff;
}

.form {
  width: 92%;
  margin-left: 4%;
  margin-top: 8px;

  .recharge_wrap {
    width: 100%;
    padding: 0;
    color: #fff;
    border-radius: 2px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-content: center;
    gap: 0.2rem 0.24rem;
    margin-bottom: 0.24rem;
  }

  .tit {
    // height: 40px;
    border-bottom: 1px solid #ff79ff;
    font-size: 16px;
    //color: #fff;
    font-weight: bold;
    line-height: 54px;
    padding-bottom: 1px;
    margin-bottom: 3px;
  }

  .item {
    height: 45px;
    width: 100%;
    //border-bottom: 1px solid #ECECEC;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;

    &:last-child {
      border-bottom: none;
    }

    .check {
      position: absolute;
      width: 16px;
      height: 16px;
      right: 0px;
      background-size: 100% 100%;

      &.checked {
        background-size: 100% 100%;
      }
    }

    .re_icon {
      width: 20px;
      height: 20px;
      margin-left: 11px;

      img {
        width: 28px;
        height: 20px;
      }
    }

    .re_name {
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
      margin-left: 3px;
    }
  }
}

.tip {
  // width: 100%;
  // margin-top: 8px;
  // border-radius: 5px;
  // padding: 8px;
  color: #e5e5e5;
  line-height: 24px;
  font-size: 0.3rem;
  margin-left: 4%;
  margin-top: 0.21053rem;
  margin-right: 3%;
  // background: #000;
}

.sbtn {
  margin: 0.1rem auto 0 auto;
  width: 92%;
  border-radius: 0.2rem;
  font-size: 0.35rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  background: @rechargeColor;
  color: @primary-color;
  margin-bottom: 2rem;
  //border: thin solid #031638;
}

.recharge_amount_p {
  font-size: 0.32rem;
  color: #fff;
  margin: 0.3rem auto;
}
</style>
